import React, { FC } from "react";
import { SessionItem, SessionRenderingContext } from "@/mds/components/sessions/session-item";
import { SessionItemFadeInAnimation } from "@/mds/components/sessions/session-item/session-item-fade-in-animation";
import { SessionItemContent } from "@/mds/components/sessions/session-item/session-item-content";
import { SessionItemErrorBoundary } from "./session-error-boundary";

interface Props {
  data: SessionItem;
  context: SessionRenderingContext;
}

export const SessionItemRenderer: FC<Props> = ({ data: item, context }) => {
  return (
    <SessionItemErrorBoundary itemId={item.id}>
      <SessionItemFadeInAnimation key={item.id}>
        <SessionItemContent item={item} context={context} />
      </SessionItemFadeInAnimation>
    </SessionItemErrorBoundary>
  );
};
